import { render, staticRenderFns } from "./ModalEditLimiteLtda.vue?vue&type=template&id=2f9163d1&scoped=true&lang=true&"
import script from "./ModalEditLimiteLtda.vue?vue&type=script&lang=js&"
export * from "./ModalEditLimiteLtda.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditLimiteLtda.vue?vue&type=style&index=0&id=2f9163d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9163d1",
  null
  
)

export default component.exports